import {gsap, Power1} from 'gsap'
import {SplitText} from 'gsap/SplitText'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {Swiper} from 'swiper'
import {FreeMode} from 'swiper/modules'
import CustomEase from 'gsap/CustomEase'
import SwiperListener from 'swipe-listener'
import {breakpointUp, getScreenWidth} from '../utils/breakpoints'

gsap.registerPlugin(SplitText)

function initContentAnimation() {

  const texts = document.querySelectorAll('.block-services-slider .slide-content h3')
  const buttons = document.querySelectorAll('.block-services-slider .slide-content .content-btn')

  texts.forEach(text => {
    texts.split = new SplitText(text, {
      type: "lines, words, chars",
      linesClass: "split-line",
      charsClass: 'split-char',
      position: 'relative',
      reduceWhiteSpace: false
    })
  })

  buttons.forEach(btn => {
    gsap.set(btn, {opacity: 0})
  })

}

function init() {

  if (!$('.block-services-slider').length) {
    return false
  }

  initBlockAnimation()

  initContentAnimation()

  const $body = $('body')
  const $navSwiperWrapper = $('.services-slider-navigation .swiper-wrapper')
  const $navAnimateLine = $('.block-services-slider .nav-line')
  const $arrowNext = $('.service-slide-arrows .arrow-next')
  const $arrowPrev = $('.service-slide-arrows .arrow-prev')
  const $arrowSlide = $('.service-slide-arrows .slide-arrow')

  let navSwiper = new Swiper('.services-slider-navigation', {
    modules: [FreeMode],
    spaceBetween: 0,
    slidesPerView: 'auto',
    freeMode: {
      enabled: true
    },
    loop: false
  })
  let isManualNavigation = false;


  $('.services-slider-navigation').find('.swiper-slide').on('click', function () {
    let index = $(this).index(); // Get the index of clicked slide
    isManualNavigation = true; // Set flag for manual navigation
    navSwiper.slideTo(index); // Scroll to the clicked slide
  });

  navSwiper.on('slideChangeTransitionEnd', function () {
    if (isManualNavigation) {
      // navAnimation(navSwiper.activeIndex)
      navSwiper.slideTo(activeIndex); // Scroll to the clicked slide
      isManualNavigation = false; // Reset flag after handling
    }
  })

  let activeIndex = 0
  let images = document.querySelectorAll('.services-slider-slides .slide-bg')
  images = [...images]
  images = images.reverse()

  let imagesLength = images.length - 1

  let content = document.querySelectorAll('.service-slider-content-slides .slide-content')
  let contentLength = content.length - 1

  $body.on('click', '.services-slider-navigation [data-index]', function () {
    let index = parseInt($(this).attr('data-index'))

    if (index === activeIndex) return false

    let move = index < activeIndex ? 'prev' : 'next'

    changeSlide(index, move)

  })

  const serviceSliderEl = $('.services-slider-slides')
  let svg = $('.js--custom-service-slider-cursor').find('.svg-rect')

  $body.on('click', '.services-slider-slides', function (e) {
    if ($(window).width() >= 1280) {
      svg.css({
        strokeDashoffset: svg.attr('data-hover') * (e.clientX > $(window).width() / 2 ? -1 : 1),
        transition: 'all 1s'
      })

      setTimeout(function () {
        svg.css({
          strokeDashoffset: svg.attr('data-default') * (e.clientX > $(window).width() / 2 ? -1 : 1),
          transition: 'none'
        })
      }, 1050)


      if (e.clientX > $(window).width() / 2 && activeIndex === imagesLength) {
        changeSlide(0, 'prev')
        activeIndex = 0
        navSwiper.slideTo(activeIndex);
        return
      }
      if (e.clientX < $(window).width() / 2 && activeIndex === 0) {
        changeSlide(imagesLength, 'next')
        activeIndex = imagesLength
        navSwiper.slideTo(activeIndex);
        return
      }

      if (e.clientX > $(window).width() / 2 && activeIndex < imagesLength) {
        changeSlide(activeIndex + 1, 'next')
        navSwiper.slideTo(activeIndex + 1);

      }

      if (e.clientX < $(window).width() / 2 && activeIndex > 0) {
        changeSlide(activeIndex - 1, 'prev')
        navSwiper.slideTo(activeIndex - 1);

      }
    }
  })

  serviceSliderEl.on('mousemove', function (event) {
    if ($(window).width() >= 1280) {

      var offset = $(this).offset();
      var relativeX = event.pageX - offset.left;
      var relativeY = event.pageY - offset.top;
      var rectHeight = $('.js--custom-service-slider-cursor .svg-rect').outerHeight() / 2
      var rectHeightRotated = Math.sqrt(2) * rectHeight;

      if (relativeX - rectHeightRotated < 0 || relativeY - rectHeightRotated < 0 || relativeX + rectHeightRotated > $(this).width() || relativeY + rectHeightRotated > $(this).outerHeight()) {
        $('.js--custom-service-slider-cursor').removeClass('shown');
      } else {
        $('.js--custom-service-slider-cursor').addClass('shown');
      }

      if (relativeX > $(window).width() / 2) {
        $('.js--custom-service-slider-cursor').addClass('rotated')
        svg.css({strokeDashoffset: svg.attr('data-default') * -1})
      } else {
        $('.js--custom-service-slider-cursor').removeClass('rotated')
        svg.css({strokeDashoffset: svg.attr('data-default')})
      }
      gsap.set('.js--custom-service-slider-cursor', {left: relativeX, top: relativeY});

    }
  });


  // Mouse leaves
  serviceSliderEl.on('mouseleave', function () {
    $('.js--custom-service-slider-cursor').removeClass('shown')
  });


  function changeSlide(index, move) {
    isManualNavigation = true; // Set flag for manual navigation

    $('.services-slider-slides .slide-bg').removeClass('is-upper')

    let goX = move === 'prev' ? '-5%' : '5%'
    let clipPath = move === 'prev' ? 'polygon(140% 0, 100% 0, 100% 100%, 100% 100%)' : 'polygon(0 0, -40% 0, 0% 100%, 0% 100%)'
    if ($('.js--sound-button').hasClass('js--sound-enabled')) {
      if (move === 'prev') {
        $("#sliderLeft")[0].currentTime = 0;
        $("#sliderLeft")[0].play();
      } else {
        $("#sliderRight")[0].currentTime = 0;
        $("#sliderRight")[0].play();
      }
    }
    for (let i = 0; i <= imagesLength; i++) {
      if (activeIndex === i) {
        gsap.fromTo(images[i], {clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'}, {
          clipPath: clipPath,
          delay: 0.10,
          duration: 0.50,
          ease: Power1.easeIn
        })
        $(images[i]).addClass('is-upper').show()
      } else if (index === i) {
        gsap.set(images[i], {x: 0, clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'})
        gsap.fromTo(images[i], {x: goX}, {x: 0, delay: 0.2, duration: 0.25, ease: Power1.easeOut})
        $(images[i]).show()
      } else {
        $(images[i]).hide()
      }
    }

    activeIndex = index

    runContentAnimation(activeIndex)

    navAnimation(activeIndex)

    arrowDisable(activeIndex)

  }

  function runContentAnimation(activeIndex) {
    for (let i = 0; i <= contentLength; i++) {
      if (activeIndex === i) {
        $(content[i]).addClass('is-active')
        gsap.fromTo('.service-slider-content-slides [data-index="' + i + '"] .split-char', {opacity: 0}, {
          opacity: 1,
          delay: 0.4,
          duration: 0.3,
          stagger: 0.01
        })
        gsap.fromTo('.service-slider-content-slides [data-index="' + i + '"] .split-char', {
          y: 10,
          rotateX: -90
        }, {
          rotateX: 0,
          y: 0,
          duration: 0.6,
          delay: 0.4,
          stagger: 0.015,
          ease: CustomEase.create("custom", "M0,0 C0.435,0.25 0.15,0.965 1,1 ")
        })

        gsap.fromTo('.service-slider-content-slides [data-index="' + i + '"] .content-btn', {opacity: 0}, {
          opacity: 1,
          delay: 1.05,
          duration: 0.25
        })
      } else {
        $(content[i]).removeClass('is-active')
      }
    }
  }

  function navAnimation(index) {
    $(navSwiper.slides).removeClass('active-underline')
    $(navSwiper.slides[index]).addClass('active-underline')
  }

  function arrowDisable(index) {
    $arrowSlide.removeClass('is-disabled')

    if (index === 0) {
      $arrowPrev.addClass('is-disabled')
    } else if (index === imagesLength) {
      $arrowNext.addClass('is-disabled')
    }
  }

  function slideAction(move) {
    const nextPosition = move === 'next' ? 1 : -1
    let index = activeIndex + nextPosition

    if (index >= 0 && index <= imagesLength) {

      changeSlide(index, move)

      nextPosition > 0 ? navSwiper.slideNext() : navSwiper.slidePrev()
    }
  }

  $body.on('click', '.service-slide-arrows .slide-arrow', function () {
    slideAction($(this).attr('data-arrow'))
  })

  let container = document.querySelector('#services-slider .services-slider-slides')
  let listener = SwiperListener(container)

  container.addEventListener('swipe', function (e) {

    if (!$('html').hasClass('touch')) {
      return false
    }

    let direction = e.detail.directions

    if (direction.left) slideAction('next')

    if (direction.right) slideAction('prev')
  })

  function initBlockAnimation() {

    gsap.set('#services-slider .slider-nav', {opacity: 0})
    gsap.set('#services-slider .c-overlay', {opacity: 0})
    gsap.set('#services-slider .services-slider-slides', {opacity: 0, scale: 1.2})

    ScrollTrigger.create({
      trigger: '#services-slider',
      // markers: true,
      scrub: true,
      start: "top-=20% center",
      end: 'bottom top',
      once: true,
      onEnter: self => {
        gsap.to('#services-slider .services-slider-slides', {opacity: 1, delay: 0.15, scale: 1, duration: 1})
        gsap.to('#services-slider .c-overlay', {opacity: 1, duration: 0.5})
        gsap.to('#services-slider .slider-nav', {opacity: 1, delay: 1, duration: 0.5})

        setTimeout(function () {
          runContentAnimation(0)
        }, 500)
      }
    })
  }
}


window.initImageZoomInEffect = () => {
  if ($('.js-image-zoom-in-effect').length) {
    gsap.set('.js-image-zoom-in-effect img', {opacity: 0, scale: 1.2});

    let sections = gsap.utils.toArray('.js-image-zoom-in-effect img');
    sections.forEach(section => {
      ScrollTrigger.create({
        trigger: section,
        // markers: true,
        scrub: true,
        start: "top-=20% center",
        end: 'bottom top',
        once: true,
        onEnter: () => {
          gsap.to(section, {opacity: 1, delay: 0.15, scale: 1, duration: 2})
        }
      })
    });
  }
}

initImageZoomInEffect();
init()
